import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2 } from 'lucide-react';
export function WhatYouGet() {
  const items = [{
    title: 'El eBook Principal:',
    desc: '«Después del Engaño: 7 pasos para sanar y decidir si quedarte o irte» (Guía completa).'
  }, {
    title: 'El Detector de Arrepentimiento:',
    desc: 'Una lista de verificación para saber si tu pareja está fingiendo o si hay un cambio real.'
  }, {
    title: 'Protocolo DETENTE:',
    desc: 'La técnica exacta para frenar los pensamientos intrusivos y las imágenes mentales del engaño.'
  }, {
    title: 'Test de Viabilidad Relacional:',
    desc: 'Un cuestionario clínico para saber si tu relación es rescatable o está muerta.'
  }, {
    title: 'Guía de Transparencia Radical:',
    desc: 'Cómo establecer reglas de seguridad digital sin convertirte en un detective privado.'
  }];
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-brand-dark" data-id="element-226">
      <div className="max-w-6xl mx-auto" data-id="element-227">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-228">
          <FadeIn className="order-2 lg:order-1" data-id="element-229">
            <div className="relative" data-id="element-230">
              <div className="absolute inset-0 bg-brand-amber/10 blur-[80px] rounded-full" data-id="element-231"></div>
              <img src="https://cdn.magicpatterns.com/uploads/t6bcujtdkFSoAPDGkWZg7N/Black_Minimalist_Global_Tech_Logo.png" alt="Libro Después del Engaño" className="relative z-10 w-full max-w-md mx-auto drop-shadow-2xl" data-id="element-232" />
            </div>
          </FadeIn>

          <div className="order-1 lg:order-2" data-id="element-233">
            <FadeIn data-id="element-234">
              <h2 className="text-3xl sm:text-4xl font-serif text-brand-amber mb-10" data-id="element-235">
                Lo que recibes hoy
              </h2>
            </FadeIn>

            <div className="space-y-6" data-id="element-236">
              {items.map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-237">
                  <div className="flex items-start gap-4" data-id="element-238">
                    <CheckCircle2 className="w-6 h-6 text-brand-amber flex-shrink-0 mt-1" data-id="element-239" />
                    <div data-id="element-240">
                      <span className="font-semibold text-brand-offwhite block mb-1" data-id="element-241">
                        {item.title}
                      </span>
                      <span className="text-brand-offwhite/70 leading-relaxed" data-id="element-242">
                        {item.desc}
                      </span>
                    </div>
                  </div>
                </FadeIn>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}